// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exploreWrapper--hhPnn {
  position: relative;
}

/* Container and Grid - Replace UIKit */
.container--hr9Gy {
  max-width: 1394px; /* Zero padding on mobile */
}
[dir] .container--hr9Gy {
  margin: 0 auto;
  padding: 0;
}

@media (min-width: 640px) {
  [dir=ltr] .container--hr9Gy {
    padding-left: 30px;
    padding-right: 30px;
  }
  [dir=rtl] .container--hr9Gy {
    padding-right: 30px;
    padding-left: 30px;
  }
}
@media (min-width: 768px) {
  [dir=ltr] .container--hr9Gy {
    padding-left: 40px;
    padding-right: 40px;
  }
  [dir=rtl] .container--hr9Gy {
    padding-right: 40px;
    padding-left: 40px;
  }
}

.grid--uCvSy {
  display: flex;
  flex-wrap: wrap;
}

[dir] .grid--uCvSy {
  margin: 0;
}

.fullWidth--gbYwi {
  width: 100%;
  box-sizing: border-box;
}

[dir] .fullWidth--gbYwi.withPadding--xMNHs {
  padding: 0 15px;
}

[dir] .title--gSgeC {
  text-align: center;
  margin: 0;
}

[dir] .errorText--I_nv7 {
  text-align: center;
  margin: 0;
}

.dropdownButton--opAc_ {
  width: 100%;
}

[dir=ltr] .dropdownButton--opAc_ {
  text-align: left;
}

[dir=rtl] .dropdownButton--opAc_ {
  text-align: right;
}

/* Desktop column widths */
@media (min-width: 640px) {
  .desktopColumn3--KuJnK {
    width: 33.333%;
  }
  [dir] .desktopColumn3--KuJnK {
    padding: 0 10px;
  }

  .desktopColumn4--KTB6K {
    width: 25%;
  }

  [dir] .desktopColumn4--KTB6K {
    padding: 0 10px;
  }

  .desktopTabHeader--lfCUI {
    flex-grow: 1;
  }

  .navigationButtonWrapper--PVHKS {
    width: 25%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  [dir] .navigationButtonWrapper--PVHKS {
    padding: 0 10px;
  }

  .grid--uCvSy { /* Negative margin for desktop grid gutter */
  }

  [dir] .grid--uCvSy {
    margin: 0 -10px;
  }
}

/* Desktop Layout - All dropdowns visible with icons above */
.dropdownWrapper--POSSN {
  display: flex;
  flex-direction: column;
}

.desktopTabHeader--lfCUI {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  transition: opacity 0.2s ease;
}

[dir] .desktopTabHeader--lfCUI {
  cursor: pointer;
}

.desktopTabHeader--lfCUI:hover {
  opacity: 0.8;
}

.desktopIcon--dhQo5 {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.desktopLabel--dlyqE {
  color: white;
  font-size: 14px;
  font-weight: 600;
}

[dir=ltr] .desktopLabel--dlyqE {
  text-align: left;
}

[dir=rtl] .desktopLabel--dlyqE {
  text-align: right;
}

/* Mobile Layout - Tab-based navigation */
.mobileTabNavigationWrapper--hvoUb {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  width: 100%;
}

.mobileTab--HA3Ux {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  transition: background-color 0.2s ease;
  flex: 1;
  min-width: 0;
  color: white;
}

[dir] .mobileTab--HA3Ux {
  padding: 15px 5px;
  cursor: pointer;
  background-color: transparent;
}

[dir] .mobileTab--HA3Ux:hover:not(.mobileTabActive--KDran) {
  background-color: rgba(255, 255, 255, 0.1);
}

.mobileTabActive--KDran {
  position: relative;
}

[dir] .mobileTabActive--KDran {
  background-color: white;
}

[dir=ltr] .mobileTabActive--KDran {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

[dir=rtl] .mobileTabActive--KDran {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.mobileTabActive--KDran::after {
  content: '';
  position: absolute;
  bottom: 0;
  height: 3px;
}

[dir] .mobileTabActive--KDran::after {
  background-color: #f26522;
}

[dir=ltr] .mobileTabActive--KDran::after {
  left: 15px;
  right: 15px;
}

[dir=rtl] .mobileTabActive--KDran::after {
  right: 15px;
  left: 15px;
}

[dir] .mobileTabActive--KDran:hover {
  background-color: white;
}

.mobileTabIcon--xVPPp {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.mobileTabActive--KDran .mobileTabIcon--xVPPp {
  filter: brightness(0.2);
}

.mobileTabLabel--FbmNG {
  color: white;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 600;
}

[dir] .mobileTabLabel--FbmNG {
  text-align: center;
}

.mobileTabActive--KDran .mobileTabLabel--FbmNG {
  color: #343c42;
}

.mobileTabActive--KDran:hover .mobileTabLabel--FbmNG {
  color: #343c42;
}

.mobileTabActive--KDran:hover .mobileTabIcon--xVPPp {
  filter: brightness(0.2);
}

.mobileDropdownButton--mO9v1 {
  width: 100%; /* Inner padding for content without affecting background */
  box-sizing: border-box;
}

[dir] .mobileDropdownButton--mO9v1 {
  padding: 0 15px;
}

.mobileDropdownHidden--sCXGw {
  display: none;
}

/* Mobile-specific styles - hide desktop, show tab navigation */
@media (max-width: 639px) {
  /* Hide desktop dropdowns */
  .dropdownWrapper--POSSN {
    display: none !important;
  }

  .desktopColumn3--KuJnK,
  .desktopColumn4--KTB6K {
    display: none !important;
  }

  /* Mobile tab navigation is always flex now */
  .mobileTabNavigationWrapper--hvoUb {
    display: flex !important;
  }

  /* Mobile dropdown is visible */
  .mobileDropdownButton--mO9v1 {
    display: block !important;
  }
  [dir] .mobileDropdownButton--mO9v1 {
    background: white;
  }

  .mobileDropdownHidden--sCXGw {
    display: none !important;
  }
}

/* Desktop-specific styles - show desktop layout, hide mobile */
@media (min-width: 640px) {
  /* Show desktop dropdowns with headers */
  .dropdownWrapper--POSSN {
    display: flex !important;
  }

  .desktopColumn3--KuJnK,
  .desktopColumn4--KTB6K {
    display: flex !important;
    flex-direction: column;
  }

  /* Hide mobile elements */
  .mobileTabNavigationWrapper--hvoUb {
    display: none !important;
  }

  .mobileDropdownButton--mO9v1 {
    display: none !important;
  }

  /* Use global classes for reliable responsive behavior */
  .explore-mobile-tabs {
    display: none !important;
  }

  .explore-mobile-dropdown {
    display: none !important;
  }
}

/* Global class styling */
.explore-desktop-dropdown {
  display: flex;
  flex-direction: column;
}

.explore-mobile-tabs {
  display: none;
}

.explore-mobile-dropdown {
  display: none;
}

@media (max-width: 639px) {
  .explore-desktop-dropdown {
    display: none !important;
  }

  .explore-mobile-tabs {
    display: flex !important;
  }

  .explore-mobile-dropdown {
    display: flex !important;
    flex-direction: column;
  }

  .explore-mobile-dropdown-hidden {
    display: none !important;
  }
}

.dropdownButtonWrapper--kp_VD {
  position: relative;
}

.dropdownButtonActive--u02rL {
  box-sizing: border-box;
}

[dir] .dropdownButtonActive--u02rL {
  border: 2px solid #e6512d !important;
  border-radius: 8px;
}

.dropdownPointer--s0Tv4 {
  position: absolute;
  bottom: -8px;
  width: 16px;
  height: 16px;
  z-index: 101;
}

[dir] .dropdownPointer--s0Tv4 {
  background: white;
  border-bottom: 2px solid #e6512d;
}

[dir=ltr] .dropdownPointer--s0Tv4 {
  left: 40px;
  border-right: 2px solid #e6512d;
  transform: rotate(45deg);
}

[dir=rtl] .dropdownPointer--s0Tv4 {
  right: 40px;
  border-left: 2px solid #e6512d;
  transform: rotate(-45deg);
}

@media (min-width: 640px) {
  .dropdownPointer--s0Tv4 {
    bottom: 7px;
  }
}

.exploreBarSelectionError--Jkiar {
  position: relative;
  height: 0;
  width: 40%;
  z-index: 140;
  top: 50px;
}

[dir=ltr] .exploreBarSelectionError--Jkiar {
  left: 30%;
}

[dir=rtl] .exploreBarSelectionError--Jkiar {
  right: 30%;
}

.exploreBarSelectionErrorInner--J_fJ2 {
  color: white;
  bottom: 20px;
}

[dir] .exploreBarSelectionErrorInner--J_fJ2 {
  background-color: #343c42;
  padding: 10px;
  border-radius: 10px;
}

[dir] .exploreBarSelectionErrorInner--J_fJ2 p {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/ExplorePanel/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,iBAAiB,EAEL,2BAA2B;AACzC;AAJA;EAEE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EAHA;IACE,mBAAkB;IAClB,kBAAmB;EACrB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EAHA;IACE,mBAAkB;IAClB,kBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;AAEjB;;AAJA;EAGE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;AAEb;;AAHA;EAEE,gBAAgB;AAClB;;AAHA;EAEE,iBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE;IACE,cAAc;EAEhB;EAHA;IAEE,eAAe;EACjB;;EAEA;IACE,UAAU;EAEZ;;EAHA;IAEE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IAEV,aAAa;IACb,sBAAsB;IACtB,yBAAyB;EAC3B;;EANA;IAEE,eAAe;EAIjB;;EAEA,eACmB,4CAA4C;EAC/D;;EAFA;IACE,eAAe;EACjB;AACF;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EAER,6BAA6B;AAC/B;;AARA;EAME,eAAe;AAEjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAElB;;AALA;EAIE,gBAAgB;AAClB;;AALA;EAIE,iBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EAGN,sCAAsC;EAEtC,OAAO;EACP,YAAY;EACZ,YAAY;AACd;;AAbA;EAME,iBAAiB;EACjB,eAAe;EAEf,6BAA6B;AAI/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EAIE,kBAAkB;AACpB;;AALA;EACE,uBAAuB;AAIzB;;AALA;EAEE,6BAA6B;EAC7B,4BAA4B;AAE9B;;AALA;EAEE,4BAA6B;EAC7B,6BAA4B;AAE9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EAGT,WAAW;AAEb;;AARA;EAOE,yBAAyB;AAC3B;;AARA;EAIE,UAAU;EACV,WAAW;AAGb;;AARA;EAIE,WAAU;EACV,UAAW;AAGb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAElB;;AANA;EAKE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW,EACM,2DAA2D;EAC5E,sBAAsB;AACxB;;AAJA;EAEE,eAAe;AAEjB;;AAEA;EACE,aAAa;AACf;;AAEA,+DAA+D;AAC/D;EACE,2BAA2B;EAC3B;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA,6CAA6C;EAC7C;IACE,wBAAwB;EAC1B;;EAEA,+BAA+B;EAC/B;IACE,yBAAyB;EAE3B;EAHA;IAEE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,+DAA+D;AAC/D;EACE,wCAAwC;EACxC;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA,yBAAyB;EACzB;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,wDAAwD;EACxD;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAGE,sBAAsB;AACxB;;AAJA;EACE,oCAAoC;EACpC,kBAAkB;AAEpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EAEZ,WAAW;EACX,YAAY;EAKZ,YAAY;AACd;;AAXA;EAME,iBAAiB;EAEjB,gCAAgC;AAGlC;;AAXA;EAGE,UAAU;EAIV,+BAA+B;EAE/B,wBAAwB;AAE1B;;AAXA;EAGE,WAAU;EAIV,8BAA+B;EAE/B,yBAAwB;AAE1B;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EAEZ,SAAS;AACX;;AAPA;EAKE,SAAS;AAEX;;AAPA;EAKE,UAAS;AAEX;;AAEA;EACE,YAAY;EAIZ,YAAY;AACd;;AANA;EAEE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AAErB;;AAEA;EACE,SAAS;AACX","sourcesContent":[".exploreWrapper {\n  position: relative;\n}\n\n/* Container and Grid - Replace UIKit */\n.container {\n  max-width: 1394px;\n  margin: 0 auto;\n  padding: 0; /* Zero padding on mobile */\n}\n\n@media (min-width: 640px) {\n  .container {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n}\n@media (min-width: 768px) {\n  .container {\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n}\n\n.grid {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0;\n}\n\n.fullWidth {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.fullWidth.withPadding {\n  padding: 0 15px;\n}\n\n.title {\n  text-align: center;\n  margin: 0;\n}\n\n.errorText {\n  text-align: center;\n  margin: 0;\n}\n\n.dropdownButton {\n  width: 100%;\n  text-align: left;\n}\n\n/* Desktop column widths */\n@media (min-width: 640px) {\n  .desktopColumn3 {\n    width: 33.333%;\n    padding: 0 10px;\n  }\n\n  .desktopColumn4 {\n    width: 25%;\n    padding: 0 10px;\n  }\n\n  .desktopTabHeader {\n    flex-grow: 1;\n  }\n\n  .navigationButtonWrapper {\n    width: 25%;\n    padding: 0 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n  }\n\n  .grid {\n    margin: 0 -10px; /* Negative margin for desktop grid gutter */\n  }\n}\n\n/* Desktop Layout - All dropdowns visible with icons above */\n.dropdownWrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.desktopTabHeader {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.desktopTabHeader:hover {\n  opacity: 0.8;\n}\n\n.desktopIcon {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.desktopLabel {\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: left;\n}\n\n/* Mobile Layout - Tab-based navigation */\n.mobileTabNavigationWrapper {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  width: 100%;\n}\n\n.mobileTab {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n  padding: 15px 5px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  background-color: transparent;\n  flex: 1;\n  min-width: 0;\n  color: white;\n}\n\n.mobileTab:hover:not(.mobileTabActive) {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.mobileTabActive {\n  background-color: white;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  position: relative;\n}\n\n.mobileTabActive::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 15px;\n  right: 15px;\n  height: 3px;\n  background-color: #f26522;\n}\n\n.mobileTabActive:hover {\n  background-color: white;\n}\n\n.mobileTabIcon {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.mobileTabActive .mobileTabIcon {\n  filter: brightness(0.2);\n}\n\n.mobileTabLabel {\n  color: white;\n  font-size: 14px;\n  text-transform: uppercase;\n  font-weight: 600;\n  text-align: center;\n}\n\n.mobileTabActive .mobileTabLabel {\n  color: #343c42;\n}\n\n.mobileTabActive:hover .mobileTabLabel {\n  color: #343c42;\n}\n\n.mobileTabActive:hover .mobileTabIcon {\n  filter: brightness(0.2);\n}\n\n.mobileDropdownButton {\n  width: 100%;\n  padding: 0 15px; /* Inner padding for content without affecting background */\n  box-sizing: border-box;\n}\n\n.mobileDropdownHidden {\n  display: none;\n}\n\n/* Mobile-specific styles - hide desktop, show tab navigation */\n@media (max-width: 639px) {\n  /* Hide desktop dropdowns */\n  .dropdownWrapper {\n    display: none !important;\n  }\n\n  .desktopColumn3,\n  .desktopColumn4 {\n    display: none !important;\n  }\n\n  /* Mobile tab navigation is always flex now */\n  .mobileTabNavigationWrapper {\n    display: flex !important;\n  }\n\n  /* Mobile dropdown is visible */\n  .mobileDropdownButton {\n    display: block !important;\n    background: white;\n  }\n\n  .mobileDropdownHidden {\n    display: none !important;\n  }\n}\n\n/* Desktop-specific styles - show desktop layout, hide mobile */\n@media (min-width: 640px) {\n  /* Show desktop dropdowns with headers */\n  .dropdownWrapper {\n    display: flex !important;\n  }\n\n  .desktopColumn3,\n  .desktopColumn4 {\n    display: flex !important;\n    flex-direction: column;\n  }\n\n  /* Hide mobile elements */\n  .mobileTabNavigationWrapper {\n    display: none !important;\n  }\n\n  .mobileDropdownButton {\n    display: none !important;\n  }\n\n  /* Use global classes for reliable responsive behavior */\n  :global(.explore-mobile-tabs) {\n    display: none !important;\n  }\n\n  :global(.explore-mobile-dropdown) {\n    display: none !important;\n  }\n}\n\n/* Global class styling */\n:global(.explore-desktop-dropdown) {\n  display: flex;\n  flex-direction: column;\n}\n\n:global(.explore-mobile-tabs) {\n  display: none;\n}\n\n:global(.explore-mobile-dropdown) {\n  display: none;\n}\n\n@media (max-width: 639px) {\n  :global(.explore-desktop-dropdown) {\n    display: none !important;\n  }\n\n  :global(.explore-mobile-tabs) {\n    display: flex !important;\n  }\n\n  :global(.explore-mobile-dropdown) {\n    display: flex !important;\n    flex-direction: column;\n  }\n\n  :global(.explore-mobile-dropdown-hidden) {\n    display: none !important;\n  }\n}\n\n.dropdownButtonWrapper {\n  position: relative;\n}\n\n.dropdownButtonActive {\n  border: 2px solid #e6512d !important;\n  border-radius: 8px;\n  box-sizing: border-box;\n}\n\n.dropdownPointer {\n  position: absolute;\n  bottom: -8px;\n  left: 40px;\n  width: 16px;\n  height: 16px;\n  background: white;\n  border-right: 2px solid #e6512d;\n  border-bottom: 2px solid #e6512d;\n  transform: rotate(45deg);\n  z-index: 101;\n}\n\n@media (min-width: 640px) {\n  .dropdownPointer {\n    bottom: 7px;\n  }\n}\n\n.exploreBarSelectionError {\n  position: relative;\n  height: 0;\n  width: 40%;\n  z-index: 140;\n  left: 30%;\n  top: 50px;\n}\n\n.exploreBarSelectionErrorInner {\n  color: white;\n  background-color: #343c42;\n  padding: 10px;\n  border-radius: 10px;\n  bottom: 20px;\n}\n\n.exploreBarSelectionErrorInner p {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"exploreWrapper": `exploreWrapper--hhPnn`,
	"container": `container--hr9Gy`,
	"grid": `grid--uCvSy`,
	"fullWidth": `fullWidth--gbYwi`,
	"withPadding": `withPadding--xMNHs`,
	"title": `title--gSgeC`,
	"errorText": `errorText--I_nv7`,
	"dropdownButton": `dropdownButton--opAc_`,
	"desktopColumn3": `desktopColumn3--KuJnK`,
	"desktopColumn4": `desktopColumn4--KTB6K`,
	"desktopTabHeader": `desktopTabHeader--lfCUI`,
	"navigationButtonWrapper": `navigationButtonWrapper--PVHKS`,
	"dropdownWrapper": `dropdownWrapper--POSSN`,
	"desktopIcon": `desktopIcon--dhQo5`,
	"desktopLabel": `desktopLabel--dlyqE`,
	"mobileTabNavigationWrapper": `mobileTabNavigationWrapper--hvoUb`,
	"mobileTab": `mobileTab--HA3Ux`,
	"mobileTabActive": `mobileTabActive--KDran`,
	"mobileTabIcon": `mobileTabIcon--xVPPp`,
	"mobileTabLabel": `mobileTabLabel--FbmNG`,
	"mobileDropdownButton": `mobileDropdownButton--mO9v1`,
	"mobileDropdownHidden": `mobileDropdownHidden--sCXGw`,
	"dropdownButtonWrapper": `dropdownButtonWrapper--kp_VD`,
	"dropdownButtonActive": `dropdownButtonActive--u02rL`,
	"dropdownPointer": `dropdownPointer--s0Tv4`,
	"exploreBarSelectionError": `exploreBarSelectionError--Jkiar`,
	"exploreBarSelectionErrorInner": `exploreBarSelectionErrorInner--J_fJ2`
};
export default ___CSS_LOADER_EXPORT___;
